import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

createRoot(document.getElementById("app")).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if (module.hot) module.hot.accept();
